__turbopack_context__.v({
  "footerSpace": "styles-module__KPkLDW__footerSpace",
  "item": "styles-module__KPkLDW__item",
  "mainItem": "styles-module__KPkLDW__mainItem",
  "muted": "styles-module__KPkLDW__muted",
  "section": "styles-module__KPkLDW__section",
  "wrapper": "styles-module__KPkLDW__wrapper",
});
